var Modal = require('../../src/js/client/components/EnhancedModal').default;

exports._enhancedModal = Modal;
